/* eslint-disable react/no-array-index-key */
import { GridFields } from 'components';
import { Stack, Typography } from 'libs/ui';
import { Colors } from 'libs/ui/theme';
import {
  CountryRiskBadges,
  CountryRiskBadgesProps,
} from 'modules/client/common/feature';

interface ClientMainInfoProps {
  info: {
    label: string;
    value?: string;
    countryRisk?: CountryRiskBadgesProps;
  }[][];
}

export const ClientMainInfo = ({ info }: ClientMainInfoProps) => (
  <GridFields datax="mainInfo">
    {info.map((row, rowIndex) => (
      <Stack key={String(rowIndex)} datax="mainInfo-box" spacing={16}>
        {row.map((item, itemIndex) => {
          const value = (
            <Typography
              className="ellipsisText"
              datax="mainInfo-item-value"
              title={item.value}
              variant="bodyMedium"
            >
              {item.value || '—'}
            </Typography>
          );

          return (
            <Stack key={String(itemIndex)}>
              <Typography color={Colors.gray700} variant="caption">
                {item.label}
              </Typography>
              {item.countryRisk ? (
                <Stack alignItems="center" direction="row" spacing={4}>
                  {value}
                  <CountryRiskBadges {...item.countryRisk} />
                </Stack>
              ) : (
                value
              )}
            </Stack>
          );
        })}
      </Stack>
    ))}
  </GridFields>
);
